(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7710],{

/***/ 37012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "We": function() { return /* binding */ getAddressSuggestions; },
/* harmony export */   "qN": function() { return /* binding */ refreshCart; },
/* harmony export */   "tz": function() { return /* binding */ getShippingAddressFormated; },
/* harmony export */   "wQ": function() { return /* binding */ getEventInfo; },
/* harmony export */   "xj": function() { return /* binding */ checkInactivePromos; }
/* harmony export */ });
/* unused harmony export createOrder */
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88032);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46201);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11763);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55760);
/* harmony import */ var _utils_payment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87864);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64757);
/* harmony import */ var _constants___WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96301);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73350);
/* harmony import */ var _store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60475);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];









const getAddressSuggestions = async (addr)=>{
    if (!addr || addr.trim() === "") return [];
    try {
        const res = await _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .addresssSuggest */ .th)(addr));
        if (res && res.payload && res.payload.results) {
            var _suggestion;
            return res.payload.results.map((item)=>(_suggestion = item.suggestion) !== null && _suggestion !== void 0 ? _suggestion : "");
        }
        return [];
    } catch (err) {
        console.log("Failed to get suggestions from Experian", err);
        throw err;
    }
};
const refreshCart = async ()=>{
    var ref, ref1;
    const cart = (ref = _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
    const { lineItems =[] , taxedPrice ={}  } = cart;
    if ((lineItems === null || lineItems === void 0 ? void 0 : lineItems.length) === 0) return;
    const shippingZip = localStorage.getItem("shippingZip");
    let payload = {};
    if (shippingZip && shippingZip.trim() !== "" && !taxedPrice) {
        payload = {
            actions: [
                {
                    action: "recalculate",
                    updateProductData: true
                },
                {
                    action: "calculateTax"
                }
            ]
        };
    } else {
        payload = {
            actions: [
                {
                    action: "recalculate",
                    updateProductData: true
                }
            ]
        };
    }
    await _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .addToCart */ .Xq)(payload)).unwrap().then((res)=>{
        if (res) {
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCart */ .RV)(res));
            const quantityLineItems = res === null || res === void 0 ? void 0 : res.lineItems;
            const payload = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_2__/* .getQuantityCount */ .PW)(quantityLineItems);
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCartCount */ .oJ)(payload));
        }
    });
};
const checkInactivePromos = async function(cb, cb1) {
    let isModalOpen = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ref, ref1;
    const actions = [];
    let actionData;
    const cart = (ref = _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === null || _store__WEBPACK_IMPORTED_MODULE_0__/* .store */ .h === void 0 ? void 0 : _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.cart;
    const { discountCodes =[]  } = cart;
    const { checkout: { paymentMethodName =""  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState();
    discountCodes.filter((item)=>item.state !== "MatchesCart").map((item)=>{
        var ref;
        actions.push({
            action: "removeDiscountCode",
            discountCode: {
                typeId: "discount-code",
                id: (ref = item.discountCode) === null || ref === void 0 ? void 0 : ref.id
            }
        });
        actionData = [
            ...actions
        ];
    });
    if ((actionData === null || actionData === void 0 ? void 0 : actionData.length) > 0) {
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .discount */ .Al)({
            actions: actionData
        })).unwrap().then((res)=>{
            if (res && res.type === "Cart") {
                _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .addToCart */ .Xq)({
                    actions: [
                        {
                            action: "calculateTax"
                        }
                    ]
                })).unwrap().then((resp)=>{
                    if (resp && resp.type === "Cart") {
                        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCart */ .RV)(res));
                        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .setCartCount */ .oJ)(res.lineItems));
                        createOrder(cb, cb1, isModalOpen, paymentMethodName);
                    }
                });
            }
        });
    } else {
        createOrder(cb, cb1, isModalOpen, paymentMethodName);
    }
    return actionData;
};
const createOrder = async function(cb, cb1) {
    let isModalOpen = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ref, ref1;
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setPaymentErrorMessageAction */ .Fc)(""));
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setPaymentFailedAction */ .RM)(false));
    const paymentId = (ref = _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState()) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : ref1.paymentId;
    const { checkout: { paymentMethodName =""  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState();
    const { generic: { globalConfig: { general: { siteName ="" , orderConfirmPath ="/" , homepageUrl ="/"  } = {}  } = {}  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState();
    const orderConfirmUrl = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getShortenedUrlPath */ .mXk)(orderConfirmPath);
    const homePagePath = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getShortenedUrlPath */ .mXk)(homepageUrl);
    const { IGLOO: { getBlackbox  } = {}  } = window || {};
    const { blackbox , finished  } = (getBlackbox === null || getBlackbox === void 0 ? void 0 : getBlackbox()) || {};
    const payload = {
        paymentId: paymentId,
        orderSource: siteName
    };
    if (finished) {
        payload.deviceId = encodeURIComponent(blackbox !== null && blackbox !== void 0 ? blackbox : "");
    }
    _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .orderSubmit */ .aN)(payload)).unwrap().then((res)=>{
        const { parentOrder: { orderNumber ="" , customerEmail: email = ""  }  } = res;
        if (res) {
            const base64Str = Buffer.from(email).toString("base64");
            const redirectionLink = "".concat(orderConfirmUrl, "?orderNumber=").concat(orderNumber).concat("&q=".concat(base64Str));
            cb1 && cb1(redirectionLink, isModalOpen, paymentMethodName);
            window.history.replaceState(null, null, homePagePath);
            window.location.href = redirectionLink;
        } else {
            cb && cb(false) // enable Place Order CTA on failure
            ;
        }
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setPaymentFailedAction */ .RM)(false));
    }).catch((error)=>{
        const { error: errorMsg , paymentCompleted =false  } = error;
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setPaymentFailedAction */ .RM)(true));
        if (paymentCompleted) {
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setPaymentTechnicalFailedAction */ .t5)(true));
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setIsPaymentInfoAction */ .hK)(true));
        // popup condition
        } else if (errorMsg === "Declined") {
            (0,_utils_cart__WEBPACK_IMPORTED_MODULE_2__/* .deleteFromCart */ .EI)();
            window.location.href = _constants_routes__WEBPACK_IMPORTED_MODULE_5__/* .FRAUD_DECLINED_MESSAGE_ENDPOINT */ .Ht;
        } else {
            _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_1__/* .getCart */ .dv)()).unwrap().then(async ()=>{
                await refreshCart();
                callErrorMessge(error);
            });
            cb && cb(false);
        }
    });
};
const callErrorMessge = async (error)=>{
    const { generic: { aciPaymentErrorMessagesPath ="" , globalConfig: { general: { checkoutPagePath ="/"  } = {}  } = {}  } = {} , checkout: { cardLastDigit =""  } = {}  } = _store__WEBPACK_IMPORTED_MODULE_0__/* .store.getState */ .h.getState();
    const isXpp = (0,_utils_payment__WEBPACK_IMPORTED_MODULE_4__/* .checkExpPayPal */ .DV)();
    const checkoutUrl = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getShortenedUrlPath */ .mXk)(checkoutPagePath);
    if (isXpp) {
        window.history.replaceState(null, null, checkoutUrl);
    }
    const { error: errorMsg = "" , errorCode  } = error;
    try {
        const { data  } = await _constants_api__WEBPACK_IMPORTED_MODULE_7__/* .aemAxiosInstance.get */ .Gb.get(_constants___WEBPACK_IMPORTED_MODULE_6__.GLOBAL_CONFIGURATION_ENDPOINT + "?path=" + aciPaymentErrorMessagesPath);
        const { value: authorErrorMsg = errorMsg  } = data.find((e)=>e.text === errorCode) || {};
        const errorMessage = authorErrorMsg.replace("card-last-4-digits", cardLastDigit);
        // payment  section open error condition
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setPaymentErrorMessageAction */ .Fc)(errorMessage || _constants___WEBPACK_IMPORTED_MODULE_6__.GENERIC_ERROR_MESSAGE));
    } catch (error1) {
        // payment  section open error condition
        const errorMsgNew = errorMsg.replace("card-last-4-digits", cardLastDigit);
        _store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch((0,_store_features_checkoutSlice__WEBPACK_IMPORTED_MODULE_8__/* .setPaymentErrorMessageAction */ .Fc)(errorMsgNew || _constants___WEBPACK_IMPORTED_MODULE_6__.GENERIC_ERROR_MESSAGE));
    }
};
const getEventInfo = function(type, link) {
    let needJson = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const eventInfo = {
        eventAction: "checkout:review:" + type,
        eventName: "checkout:review:" + type,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type,
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:navigation",
        internalLinkZoneName: "checkout:review",
        internalLinkURL: link ? (link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks: "true"
    };
    if (needJson) {
        return eventInfo;
    }
    return JSON.stringify(eventInfo);
};
const getShippingAddressFormated = (data)=>{
    const { city ="" , country ="" , email ="" , firstName ="" , lastName ="" , phone ="" , postalCode ="" , state ="" , streetName ="" , streetNumber ="" , id =""  } = data;
    return {
        fname: {
            value: firstName,
            error: false,
            message: ""
        },
        lname: {
            value: lastName,
            error: false,
            message: ""
        },
        email: {
            value: email,
            error: false,
            message: ""
        },
        phone: {
            value: phone,
            error: false,
            message: ""
        },
        address1: {
            value: streetName,
            error: false,
            message: ""
        },
        address2: streetNumber,
        city: {
            value: city,
            error: false,
            message: ""
        },
        state: {
            value: state,
            error: false,
            message: ""
        },
        zipcode: {
            value: postalCode,
            error: false,
            message: ""
        },
        country: {
            value: country,
            error: false,
            message: ""
        },
        notes: "",
        label: {
            show: true,
            value: ""
        },
        id: id
    };
};


/***/ }),

/***/ 77860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_core_Input_Input__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3372);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96301);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);
/* harmony import */ var _components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8618);
/* harmony import */ var _components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_6__);







const SelectDropdown = (props)=>{
    const [showList, setShowList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [opened, setOpened] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [filteredData, setFilteredData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [filterText, setFilterText] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [isHighLighted, setIsHighLighted] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const { customClass , id , tabIndex , label , placeholder , ariaLabel , ariaRequired , value , ariaStateText , data , showError , errorMessage , showFilter  } = props;
    const { KEYCODE  } = _constants_index__WEBPACK_IMPORTED_MODULE_4__["default"];
    let isFocused = false;
    const dropDownClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()({
        "select-dropdown": true,
        "dropdown--open": showList
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showList) {
            setOpened(true);
        } else if (!showList && opened && props.onClose) {
            props.onClose();
            setOpened(false);
        }
        const targetEelement = (e)=>{
            if (showList && document.getElementById(props.id) && !document.getElementById(props.id).contains(e.target)) {
                setShowList(false);
            }
        };
        document.addEventListener("click", targetEelement);
        return ()=>{
            document.removeEventListener("click", targetEelement);
        };
    }, [
        showList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setFilteredData(data);
    }, [
        data
    ]);
    const handleSelect = (value)=>{
        props.onChange(value);
        setShowList(false);
    };
    const handleMouseDownEvent = ()=>{
        isFocused = true;
        setShowList(!showList);
    };
    const handleBlurEvent = (e)=>{
        if (!showFilter) {
            if (e instanceof MouseEvent) {
                isFocused;
                setShowList(false);
            }
            if (typeof props.onBlur === "function") {
                props.onBlur();
            }
        }
    };
    const toggleList = ()=>{
        if (showList) {
            setShowList(false);
            document.getElementById(props.id).focus();
        } else {
            var ref;
            setShowList(true);
            (ref = document.getElementById("".concat(props.id, "-list"))) === null || ref === void 0 ? void 0 : ref.childNodes[0].focus();
        }
    };
    const btnKeyDown = (e)=>{
        switch(e.keyCode){
            case KEYCODE.SPACE:
                break;
            case KEYCODE.ENTER:
                e.preventDefault();
                toggleList();
                break;
            default:
                break;
        }
    };
    const handleKeyDown = (i, e)=>{
        const ele = document.getElementById("".concat(props.id, "-list")).childNodes;
        switch(e.keyCode){
            case KEYCODE.ESC:
                toggleList();
                break;
            case KEYCODE.UP:
                if (i > 0) ele[i - 1].focus();
                break;
            case KEYCODE.DOWN:
                if (i < ele.length - 1) ele[i + 1].focus();
                break;
            case KEYCODE.SPACE:
                break;
            case KEYCODE.ENTER:
                ele[i].click();
                document.getElementById(props.id).focus();
                break;
            default:
                break;
        }
    };
    const filterCityNames = (e)=>{
        var ref;
        const key = e === null || e === void 0 ? void 0 : (ref = e.key) === null || ref === void 0 ? void 0 : ref.toLowerCase();
        if ((key === null || key === void 0 ? void 0 : key.length) === 1 && (key === null || key === void 0 ? void 0 : key.match(_constants_index__WEBPACK_IMPORTED_MODULE_4__["default"].REGEX_CONTAINS_LETTER))) {
            const filtered = data === null || data === void 0 ? void 0 : data.filter((item)=>{
                return item === null || item === void 0 ? void 0 : item.toLowerCase().startsWith(key);
            });
            setFilteredData(filtered !== null && filtered !== void 0 ? filtered : data);
        } else if (key === "backspace") {
            setFilteredData(data);
        }
    };
    const handleChange = (e)=>{
        const { value  } = e.target;
        if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .checkAlphabetOnly */ .pJD)(value)) {
            setFilterText(value);
            const key = value.toLowerCase();
            const filtered = data === null || data === void 0 ? void 0 : data.filter((item)=>{
                if (item.toLowerCase().startsWith(key)) {
                    return item;
                }
            });
            setFilteredData(filtered !== null && filtered !== void 0 ? filtered : data);
        }
    };
    const handleInputKeyDown = (e)=>{
        if (KEYCODE.DOWN === e.keyCode) {
            setIsHighLighted(isHighLighted >= filteredData.length - 1 ? 0 : isHighLighted + 1);
        } else if (KEYCODE.UP === e.keyCode) {
            setIsHighLighted(isHighLighted > 0 ? isHighLighted - 1 : 0);
        } else if (KEYCODE.ENTER === e.keyCode) {
            handleSelect(filteredData.at(isHighLighted));
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setFilterText(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_core_SelectDropdown_index_module_scss__WEBPACK_IMPORTED_MODULE_6___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            onClick: handleMouseDownEvent,
            onBlur: handleBlurEvent,
            className: "".concat(dropDownClass, " ").concat(customClass !== null && customClass !== void 0 ? customClass : ""),
            onKeyDown: filterCityNames,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    id: id,
                    className: "select-dropdown__field ".concat(showError ? "--with-error" : ""),
                    onKeyDown: btnKeyDown,
                    tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : 0,
                    role: "combobox",
                    "aria-controls": "dropdown-listbox",
                    "aria-expanded": showList,
                    "aria-haspopup": "true",
                    "aria-label": label ? label.replace(/\*/g, "") : ariaLabel ? ariaLabel.replace(/\*/g, "") : "",
                    "aria-required": (ariaRequired !== null && ariaRequired !== void 0 ? ariaRequired : label.indexOf("*") > 0) ? true : false,
                    "aria-describedby": "".concat(id, "-selected"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "select-dropdown__display",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    "aria-hidden": true,
                                    className: "select-dropdown__placeholder ".concat(value ? "--label" : ""),
                                    children: label
                                }),
                                showFilter && showList ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Input_Input__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    type: "text",
                                    className: "inputfilter",
                                    onChange: handleChange,
                                    onKeyDown: handleInputKeyDown,
                                    value: filterText,
                                    placeholder: placeholder,
                                    label: label,
                                    autoComplete: true,
                                    autoFocus: true
                                }) : null,
                                value && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    id: "".concat(id, "-selected"),
                                    className: "select-dropdown__value",
                                    children: value
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "select-dropdown__icon ".concat(showList ? "--open" : ""),
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/icons/down-icon.svg",
                                alt: "open-icon"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                    id: "".concat(id, "-list"),
                    className: "select-dropdown__dropdown",
                    role: "listbox",
                    tabIndex: "-1",
                    "aria-expanded": "true",
                    "data-testid": "select-dropdown",
                    children: [
                        !ariaStateText && (filteredData === null || filteredData === void 0 ? void 0 : filteredData.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "select-dropdown__list-item ".concat(item === value && "selected-item", " ").concat(isHighLighted === i ? "highLighted" : ""),
                                "aria-selected": item === value,
                                role: "option",
                                tabIndex: "-1",
                                onClick: ()=>handleSelect(item),
                                onKeyDown: (e)=>handleKeyDown(i, e),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "select-dropdown__list-value",
                                    children: item
                                })
                            }, i))),
                        ariaStateText && (filteredData === null || filteredData === void 0 ? void 0 : filteredData.map((item, i)=>{
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "select-dropdown__list-item ".concat(item.code === value && "selected-item"),
                                "aria-selected": item === value,
                                role: "option",
                                tabIndex: "-1",
                                "aria-label": item.name,
                                onClick: ()=>{
                                    return handleSelect((props === null || props === void 0 ? void 0 : props.showStateName) ? item === null || item === void 0 ? void 0 : item.name : item === null || item === void 0 ? void 0 : item.code);
                                },
                                onKeyDown: (e)=>handleKeyDown(i, e),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "select-dropdown__list-value",
                                    children: (props === null || props === void 0 ? void 0 : props.showStateName) ? item === null || item === void 0 ? void 0 : item.name : item === null || item === void 0 ? void 0 : item.code
                                })
                            }, i);
                        }))
                    ]
                }),
                showError && errorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    "aria-live": "polite",
                    role: "region",
                    className: "select-dropdown__error-message",
                    children: errorMessage
                })
            ]
        })
    });
};
SelectDropdown.defaultProps = {
    label: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectDropdown);


/***/ }),

/***/ 8618:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SelectDropdown_wrapper__ot64Z"};

/***/ }),

/***/ 81770:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextArea_wrapper__fJ1_4"};

/***/ })

}]);